import { HOME_URL } from "./homeUrl";

export const LOCALS_LINK = [
  {
    rel: "alternate",
    hrefLang: "en",
    href: `${HOME_URL}/en/`,
  },
  {
    rel: "alternate",
    hrefLang: "uk",
    href: `${HOME_URL}/uk/`,
  },
  {
    rel: "alternate",
    hrefLang: "uk",
    href: `${HOME_URL}/ru/`,
  },
];
